import React, { useCallback, useState, useMemo } from 'react';
import ReportsHeader from './ReportsHeader';
import { getTotalReport } from './utils';
import { RequestState } from 'shared/auth/hooks/useRequestState';
import { ReportsCountResponse } from './api';
import AddNewModals from './AddNewModals';
import { Program } from '../Reports/NewReportDialog';
import { NPOUser } from './NewProgram/api';

interface ReportAddNewProps {
  defaultProgramName: string | undefined;
  allNPOUsers: RequestState<{
    allUsers: NPOUser[];
  }>;
  programsList: RequestState<{
    allPrograms: Program[];
  }>;
  countsRequestState: RequestState<ReportsCountResponse>;
  reloadProgramList: () => unknown;
  handleReportCountLoad: () => unknown;
}

const ReportAddNew: React.FC<ReportAddNewProps> = ({
  defaultProgramName,
  countsRequestState,
  programsList,
  allNPOUsers,
  reloadProgramList,
  handleReportCountLoad,
}) => {
  const [openNewReport, setOpenNewReport] = useState<boolean>(false);
  const [openNewProgram, setOpenNewProgram] = useState<boolean>(false);
  const onNewReportClick = useCallback(() => setOpenNewReport(true), [
    setOpenNewReport,
  ]);
  const onNewProgramClick = useCallback(() => setOpenNewProgram(true), [
    setOpenNewProgram,
  ]);

  const addButtons = useMemo(
    () => [
      {
        text: 'New Report',
        onClick: onNewReportClick,
      },
      {
        text: 'New Program',
        onClick: onNewProgramClick,
      },
    ],
    [onNewReportClick, onNewProgramClick],
  );

  return (
    <>
      <ReportsHeader
        count={getTotalReport(countsRequestState.data)}
        text="Reports"
        onAdd={addButtons}
      />
      <AddNewModals
        defaultProgramName={defaultProgramName}
        allNPOUsers={allNPOUsers}
        programsList={programsList}
        openNewProgram={openNewProgram}
        openNewReport={openNewReport}
        reloadProgramList={reloadProgramList}
        setOpenNewProgram={setOpenNewProgram}
        setOpenNewReport={setOpenNewReport}
        handleReportCountLoad={handleReportCountLoad}
      />
    </>
  );
};

export default ReportAddNew;
